import { ChangeEvent, useState } from 'react';

import { MenuItem, SelectChangeEvent } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import InputForm from 'shared/components/Input/InputForm';
import { SCHCTemplateStackT } from 'shared/models/schc-templates';
import SCHCTemplate from 'shared/models/SCHCTemplate';

import SCHCTemplatesRuleFormCompressionStack from './SCHCTemplatesRuleForm.compression';
import SCHCTemplatesRuleFormFragmentation from './SCHCTemplatesRuleForm.fragmentation';

type SCHCTemplatesRuleFormProps = {
  index: number;
  stacksAvailable: Array<SCHCTemplateStackT>;
  onChangeRuleId(value: string | null): void; // eslint-disable-line
}
function SCHCTemplatesRuleForm({
  index,
  stacksAvailable,
  onChangeRuleId,
}: SCHCTemplatesRuleFormProps) {
  const {
    register,
    getValues,
    control,
    formState: {
      errors,
    },
  } = useFormContext<SCHCTemplate.Form.ValuesT>();
  const defaultType = getValues().rules[index].ruleType;
  const ruleTypes = [
    { id: SCHCTemplate.FRAGMENTATION_RULE, name: 'Fragmentation' },
    { id: SCHCTemplate.COMPRESSION_RULE, name: 'Compression' },
  ];
  const [currentType, setCurrentType] = useState(defaultType);

  const onChangeType = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    setCurrentType(value);
  };
  const ruleId = register(`rules.${index}.ruleId`);

  return (
    <>
      <InputForm.TextField
        fullWidth
        sx={{ mt: 1, mb: 1 }}
        label="Rule ID"
        register={ruleId}
        onBlur={(e: ChangeEvent) => {
          ruleId.onBlur(e);
          onChangeRuleId((e.target as HTMLInputElement).value);
        }}
        errorField={
          Array.isArray(errors.rules)
            ? errors.rules[index]?.ruleId
            : undefined
        }
      />
      <InputForm.Select
        fullWidth
        sx={{ mt: 1, mb: 1 }}
        label="Rule Type"
        name={`rules.${index}.ruleType`}
        control={control}
        hasError={
            Array.isArray(errors.rules)
            && errors.rules[index]
            && !!errors.rules[index].ruleType
          }
        defaultValue={defaultType}
        onChange={onChangeType}
      >
        {
            ruleTypes.map((type) => (
              <MenuItem key={type.id} value={type.id}>
                { type.name }
              </MenuItem>
            ))
          }
      </InputForm.Select>
      {
        currentType === SCHCTemplate.FRAGMENTATION_RULE
          ? (
            <SCHCTemplatesRuleFormFragmentation
              index={index}
            />
          )
          : null
      }
      {
        currentType === SCHCTemplate.COMPRESSION_RULE
          ? (
            <SCHCTemplatesRuleFormCompressionStack
              index={index}
              stacksAvailable={stacksAvailable}
            />
          )
          : null
      }
    </>
  );
}

export default SCHCTemplatesRuleForm;
